import type { SystemView } from "../types";
import { SYSTEM_LIST } from "../types";

export interface UnifiedEvent {
    id: string;
    time: string;
    system: SystemView;
    title: string;
    severity: "critical" | "high" | "medium" | "low";
    correlated: SystemView[];
    details: string;
    searchableText: string;
    actor?: string;
}

export const UNIFIED_EVENTS: UnifiedEvent[] = [
    {
        id: "SOC-1247",
        time: "14:23",
        system: "soc",
        title: "Brute Force — fw-prod-01",
        severity: "critical",
        correlated: ["ndr", "ztna"],
        details: "185.143.223.1 brute force attack, NDR blocked lateral movement, ZTNA session terminated",
        searchableText: "185.143.223.1 fw-prod-01 brute force",
        actor: "APT-Sigma-7",
    },
    {
        id: "SOC-1248",
        time: "14:18",
        system: "soc",
        title: "Malware Detected — edr-ws-142",
        severity: "high",
        correlated: ["mail", "ndr"],
        details: "Malware traced to Mail quarantine #Q-4821, C2 beacon detected by NDR",
        searchableText: "edr-ws-142 malware Q-4821",
        actor: "APT-Sigma-7",
    },
    {
        id: "SOC-1249",
        time: "13:55",
        system: "soc",
        title: "Data Exfiltration — proxy-ext-02",
        severity: "high",
        correlated: ["ndr", "ztna", "pentests"],
        details: "Exfiltration attempt via DNS tunneling, ZTNA session for s.braun terminated",
        searchableText: "proxy-ext-02 s.braun data exfiltration DNS",
        actor: "APT-Sigma-7",
    },
    {
        id: "SOC-1250",
        time: "13:41",
        system: "soc",
        title: "Suspicious Login — ad-dc-01",
        severity: "medium",
        correlated: ["ztna", "phishing"],
        details: "User clicked phishing link then anomalous AD login from new location",
        searchableText: "ad-dc-01 suspicious login",
        actor: "insider-risk",
    },
    {
        id: "SOC-1251",
        time: "13:12",
        system: "soc",
        title: "Port Scan — ids-dmz-03",
        severity: "low",
        correlated: ["ndr"],
        details: "Low-rate port scan from external IP, NDR flagged reconnaissance",
        searchableText: "ids-dmz-03 port scan",
    },
    {
        id: "SOC-1252",
        time: "12:58",
        system: "soc",
        title: "Malware — edr-srv-08",
        severity: "critical",
        correlated: ["mail", "ndr", "pentests"],
        details: "Server malware exploiting CVE from PT-004, payload from mail attachment",
        searchableText: "edr-srv-08 malware CVE-2024",
        actor: "APT-Sigma-7",
    },
    {
        id: "NDR-421",
        time: "14:21",
        system: "ndr",
        title: "C2 Callback Blocked",
        severity: "high",
        correlated: ["soc", "ztna"],
        details: "TCP/443 callback to 185.143.223.1 blocked, SOC Alert #1247 created",
        searchableText: "185.143.223.1 C2 callback TCP/443",
        actor: "APT-Sigma-7",
    },
    {
        id: "NDR-418",
        time: "14:15",
        system: "ndr",
        title: "SMB Lateral Movement",
        severity: "medium",
        correlated: ["soc", "pentests"],
        details: "SMB lateral movement matches pentest PT-003 attack path",
        searchableText: "10.0.8.102 SMB lateral movement",
        actor: "APT-Sigma-7",
    },
    {
        id: "NDR-415",
        time: "14:02",
        system: "ndr",
        title: "DNS Tunneling Detected",
        severity: "high",
        correlated: ["soc", "mail"],
        details: "DNS tunneling to 91.215.85.12 linked to malware from Mail quarantine",
        searchableText: "91.215.85.12 DNS tunneling",
        actor: "APT-Sigma-7",
    },
    {
        id: "NDR-412",
        time: "13:48",
        system: "ndr",
        title: "RDP Anomaly",
        severity: "medium",
        correlated: ["ztna", "pentests"],
        details: "Unusual RDP from 10.0.15.201 — ZTNA auto-restricted access",
        searchableText: "10.0.15.201 RDP anomaly lateral",
    },
    {
        id: "NDR-408",
        time: "13:30",
        system: "ndr",
        title: "HTTP Beacon",
        severity: "low",
        correlated: ["phishing"],
        details: "HTTP beacon from user who visited phishing simulation URL",
        searchableText: "10.0.1.55 HTTP beacon phishing",
    },
    {
        id: "MAIL-4821",
        time: "14:20",
        system: "mail",
        title: "Phishing — fak3-vendor.com",
        severity: "high",
        correlated: ["phishing", "soc"],
        details: "Pattern matches active Q2 IT Helpdesk campaign template",
        searchableText: "fak3-vendor.com invoice phishing INV-2847",
    },
    {
        id: "MAIL-4822",
        time: "14:12",
        system: "mail",
        title: "Spam Blocked — ch34p-meds.ru",
        severity: "low",
        correlated: ["ndr"],
        details: "Spam from known botnet, NDR added C2 domain to blocklist",
        searchableText: "ch34p-meds.ru spam",
    },
    {
        id: "MAIL-4823",
        time: "13:58",
        system: "mail",
        title: "Phishing — micros0ft-alert.com",
        severity: "high",
        correlated: ["phishing", "ztna", "soc"],
        details: "Account verification phish targeting 12 users, ZTNA flagged 3 compromised",
        searchableText: "micros0ft-alert.com account verification phishing",
    },
    {
        id: "MAIL-4824",
        time: "13:45",
        system: "mail",
        title: "Malware — pack4ge-track.cn",
        severity: "critical",
        correlated: ["soc", "ndr", "pentests"],
        details: "DHL payload uses CVE from PT-004, C2 domain added to NDR blocklist",
        searchableText: "pack4ge-track.cn DHL malware CVE-2024",
        actor: "APT-Sigma-7",
    },
    {
        id: "MAIL-4825",
        time: "13:31",
        system: "mail",
        title: "Phishing — company-update.net",
        severity: "medium",
        correlated: ["phishing", "ztna"],
        details: "HR-themed phishing, 3 employees clicked before block",
        searchableText: "company-update.net Gehaltsanpassung phishing",
    },
    {
        id: "ZTNA-091",
        time: "14:21",
        system: "ztna",
        title: "Session Denied — s.braun",
        severity: "critical",
        correlated: ["soc", "ndr", "mail"],
        details: "Unknown device from Bucharest, trust score 23, NDR flagged C2 traffic",
        searchableText: "s.braun Bucharest VPN denied trust score 23",
        actor: "APT-Sigma-7",
    },
    {
        id: "ZTNA-089",
        time: "13:58",
        system: "ztna",
        title: "Trust Score Drop — 3 users",
        severity: "medium",
        correlated: ["mail", "phishing"],
        details: "3 users received phishing, Mail Gateway blocked follow-ups",
        searchableText: "trust score drop phishing mail",
    },
    {
        id: "ZTNA-088",
        time: "13:55",
        system: "ztna",
        title: "Endpoint Compromise — j.mueller",
        severity: "high",
        correlated: ["soc", "phishing"],
        details: "Trust score dropped to 64, SOC investigating endpoint",
        searchableText: "j.mueller trust score 64 endpoint compromise",
    },
    {
        id: "ZTNA-085",
        time: "13:41",
        system: "ztna",
        title: "Phishing Click Impact — a.weber",
        severity: "medium",
        correlated: ["phishing", "soc"],
        details: "Clicked phishing simulation, trust score impact applied",
        searchableText: "a.weber phishing click trust score",
    },
    {
        id: "ZTNA-082",
        time: "11:30",
        system: "ztna",
        title: "MFA Policy Update",
        severity: "low",
        correlated: ["pentests", "soc"],
        details: "PT-003 finding: hardware tokens enforced on privileged accounts",
        searchableText: "MFA policy PT-003 hardware token",
    },
    {
        id: "PHISH-201",
        time: "14:20",
        system: "phishing",
        title: "Real Attack Matches Simulation",
        severity: "high",
        correlated: ["mail", "soc", "ztna"],
        details: "Mail Gateway caught 12 real emails matching IT Helpdesk template",
        searchableText: "IT Helpdesk campaign real attack simulation",
    },
    {
        id: "PHISH-198",
        time: "13:55",
        system: "phishing",
        title: "29 Clickers Flagged",
        severity: "medium",
        correlated: ["soc", "ztna", "ndr"],
        details: "SOC endpoint scans initiated, ZTNA scores lowered, NDR monitoring",
        searchableText: "29 clickers phishing campaign flagged",
    },
    {
        id: "PHISH-195",
        time: "12:30",
        system: "phishing",
        title: "DHL Sim Callback Attempts",
        severity: "medium",
        correlated: ["ndr", "soc"],
        details: "5 callback attempts from DHL Paket clickers, all blocked by NDR",
        searchableText: "DHL Paket callback NDR blocked",
    },
    {
        id: "PHISH-192",
        time: "09:15",
        system: "phishing",
        title: "Social Eng. Vector Match",
        severity: "low",
        correlated: ["pentests", "mail"],
        details: "PT-001 SQLi used identical social engineering vector",
        searchableText: "PT-001 social engineering SQLi vector",
    },
    {
        id: "PT-001",
        time: "14:23",
        system: "pentests",
        title: "SQL Injection — api.example.com",
        severity: "critical",
        correlated: ["soc", "ndr", "phishing"],
        details: "Live exploitation attempt detected by SOC, matches pentest vector",
        searchableText: "PT-001 SQL injection api.example.com SQLi",
        actor: "APT-Sigma-7",
    },
    {
        id: "PT-003",
        time: "11:30",
        system: "pentests",
        title: "MFA Bypass — AD DC-01",
        severity: "high",
        correlated: ["ztna", "soc", "phishing"],
        details: "ZTNA policy updated, privileged accounts now require hardware tokens",
        searchableText: "PT-003 MFA bypass AD DC-01 privileged",
    },
    {
        id: "PT-004",
        time: "13:45",
        system: "pentests",
        title: "OpenSSL CVE — lb-prod-02",
        severity: "high",
        correlated: ["mail", "ndr", "soc"],
        details: "Exploit found in malware payload from Mail Gateway quarantine",
        searchableText: "PT-004 OpenSSL CVE-2024 lb-prod-02",
        actor: "APT-Sigma-7",
    },
    {
        id: "PT-005",
        time: "12:30",
        system: "pentests",
        title: "SNMP Enumeration",
        severity: "medium",
        correlated: ["ndr"],
        details: "NDR detected SNMP enumeration matching accepted risk finding",
        searchableText: "PT-005 SNMP v2c enumeration switch-floor3",
    },
    {
        id: "PT-006",
        time: "09:00",
        system: "pentests",
        title: "Default Credentials — Printer",
        severity: "low",
        correlated: ["ndr", "ztna"],
        details: "Network printer with default creds, ZTNA segmentation in place",
        searchableText: "PT-006 default credentials printer-3f-east",
    },
];

export interface ThreatActor {
    name: string;
    type: string;
    systems: SystemView[];
    events: string[];
    ips: string[];
    users: string[];
    assets: string[];
}

export const THREAT_ACTORS: ThreatActor[] = [
    {
        name: "APT-Sigma-7",
        type: "Advanced Persistent Threat",
        systems: ["soc", "ndr", "mail", "ztna", "pentests"],
        events: [
            "SOC-1247",
            "SOC-1248",
            "SOC-1249",
            "SOC-1252",
            "NDR-421",
            "NDR-418",
            "NDR-415",
            "MAIL-4824",
            "ZTNA-091",
            "PT-001",
            "PT-004",
        ],
        ips: ["185.143.223.1", "91.215.85.12"],
        users: ["s.braun"],
        assets: ["fw-prod-01", "edr-ws-142", "edr-srv-08", "api.example.com", "lb-prod-02"],
    },
    {
        name: "insider-risk",
        type: "Insider Threat",
        systems: ["soc", "ztna", "phishing"],
        events: ["SOC-1250", "ZTNA-088", "ZTNA-085", "PHISH-198"],
        ips: [],
        users: ["j.mueller", "a.weber"],
        assets: ["ad-dc-01"],
    },
];

export interface MitreTactic {
    id: string;
    name: string;
    systems: SystemView[];
}

export const MITRE_TACTICS: MitreTactic[] = [
    { id: "TA0001", name: "Initial Access", systems: ["mail", "phishing", "soc", "ztna"] },
    { id: "TA0002", name: "Execution", systems: ["soc", "phishing", "pentests", "ndr"] },
    { id: "TA0003", name: "Persistence", systems: ["soc", "ztna"] },
    { id: "TA0004", name: "Priv. Escalation", systems: ["pentests", "soc", "ztna"] },
    { id: "TA0005", name: "Defense Evasion", systems: ["mail", "soc", "ndr"] },
    { id: "TA0006", name: "Credential Access", systems: ["soc", "ndr", "ztna", "pentests"] },
    { id: "TA0007", name: "Discovery", systems: ["ndr", "soc", "pentests"] },
    { id: "TA0008", name: "Lateral Movement", systems: ["ndr", "soc", "ztna"] },
    { id: "TA0009", name: "Collection", systems: ["ndr", "soc"] },
    { id: "TA0010", name: "Exfiltration", systems: ["ndr", "soc", "ztna"] },
    { id: "TA0011", name: "Command & Control", systems: ["ndr", "mail", "soc"] },
    { id: "TA0040", name: "Impact", systems: ["soc", "ndr"] },
];

export function getCorrelationMatrix(): number[][] {
    const matrix = SYSTEM_LIST.map(() => SYSTEM_LIST.map(() => 0));
    for (const event of UNIFIED_EVENTS) {
        const srcIdx = SYSTEM_LIST.indexOf(event.system);
        for (const cor of event.correlated) {
            const dstIdx = SYSTEM_LIST.indexOf(cor);
            if (srcIdx >= 0 && dstIdx >= 0) {
                matrix[srcIdx][dstIdx]++;
                matrix[dstIdx][srcIdx]++;
            }
        }
    }
    return matrix;
}
